<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="getData"
            :search="searchModel"
            :expanded.sync="expanded"
            :single-expand="singleExpand"
            show-expand
            item-key="fakturaKopf.nr"
            show-select
            class="elevation-1"
            :page.sync="pageModel"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:top>
              <v-toolbar flat :color="$store.getters.stdColorLight">
                <v-icon>{{ getIcon() }}</v-icon>
                <v-toolbar-title>{{ getTitle() }}</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                >
                </v-divider>
                <v-text-field
                  v-model="searchModel"
                  append-icon="search"
                  :label="$t('message.filter')"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <!-- reporting menu -->
                <v-menu
                  v-model="value"
                  :disabled="menuDisabled"
                  :absolute="absolute"
                  :open-on-hover="openOnHover"
                  :close-on-click="closeOnClick"
                  :close-on-content-click="closeOnContentClick"
                  :offset-x="offsetX"
                  :offset-y="offsetY"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-show="selected.length>0 && !$store.getters.showFakturaArchiv" icon v-on="on">
                      <v-icon>receipt</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="showReport(getReportListName(), getReportListTitle())">
                      <v-list-item-title class="subtitle-2">{{ getReportListTitle() }}</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="showReport(getReportFormName(), getReportFormTitle())">
                      <v-list-item-title class="subtitle-2">{{ getReportFormTitle() }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showReport(getReportFormNameLeft(), getReportFormTitleLeft())">
                      <v-list-item-title class="subtitle-2">{{ getReportFormTitleLeft() }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- paid dialog -->
                <v-dialog v-model="paidDialog" persistent max-width="600px">
                  <v-card>
                    <v-card-title>
                      <v-toolbar flat :color="$store.getters.stdColorLight">
                        <v-row justify="center">
                          <v-toolbar-title>{{ $t("tooltip.changeToPaid") }}</v-toolbar-title>
                        </v-row>
                      </v-toolbar>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.nr" :label="$t('faktura.nr')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.nameFirma" :label="$t('customer.name')"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.vorname" :label="$t('customer.firstName')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.totalBetrag" :label="$t('faktura.totalBetrag')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field v-model="editedItem.fakturaKopf.valutaDatum" type="date" :label="$t('faktura.valutaDatum')"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="close()">{{ $t("message.cancel") }}</v-btn>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="setPaid()" :disabled="!checkDate(editedItem)">{{ $t("message.save") }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!-- edit/new dialog -->
                <v-dialog v-model="dialog" persistent max-width="800px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-show="!($store.getters.showFakturaVerbucht || $store.getters.showFakturaArchiv)" @click="initItem()" class="white--text" :color="$store.getters.stdColorDark" v-on="on">{{ $t("message.newTitle") }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <v-toolbar flat :color="$store.getters.stdColorLight">
                        <v-row justify="center">
                          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                        </v-row>
                      </v-toolbar>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.nr" :label="$t('faktura.nr')"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="editedItem.fakturaKopf.datum" type="date" :label="$t('faktura.datum')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field v-show="!$store.getters.showRapport" v-model="editedItem.fakturaKopf.text" :label="$t('faktura.text')" max="63" counter="63" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-show="!$store.getters.showRapport" v-model="editedItem.fakturaKopf.person" :label="$t('faktura.person')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field v-show="$store.getters.showFaktura" v-model="editedItem.fakturaKopf.bestellDatum" type="date" :label="$t('faktura.bestellDatum')"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-show="$store.getters.showFaktura" v-model="editedItem.fakturaKopf.bestellart" :label="$t('faktura.bestellart')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-select
                              v-model="customerItem"                            
                              :items="$store.getters.customerList"
                              :item-text="getCustomerText"
                              :item-value="getCustomerValue"
                              :label="$t('faktura.kunde')"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-show="$store.getters.showFaktura" dense>
                          <v-col cols="12">
                            <v-select
                              v-model="lieferadresseItem"
                              :items="$store.getters.lieferadresseList"
                              :item-text="getLieferadresseText"
                              :item-value="getLieferadresseValue"
                              :label="$t('faktura.lieferadresse')"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-show="!$store.getters.showRapport" dense>
                          <v-col cols="12">
                            <v-select
                              v-model="konditionItem"
                              :items="$store.getters.konditionList"
                              :item-text="getKonditionText"
                              :item-value="getKonditionValue"
                              :label="$t('faktura.kondition')"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-show="!$store.getters.showRapport" dense>
                          <v-col cols="12">
                            <v-select
                              v-model="fzeileItem"
                              :items="$store.getters.fzeileList"
                              :item-text="getFzeileText"
                              :item-value="getFzeileValue"
                              :label="$t('faktura.faktzeile')"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row v-show="!$store.getters.showRapport" dense>
                          <v-col cols="4">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.steuerBetrag" :label="$t('faktura.steuerBetrag')"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.nettoBetrag" :label="$t('faktura.nettoBetrag')"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field disabled v-model="editedItem.fakturaKopf.totalBetrag" :label="$t('faktura.totalBetrag')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-select
                              v-model="bankkontoItem"
                              :items="$store.getters.bankkontoList"
                              :item-text="getBankkontoText"
                              :item-value="getBankkontoValue"
                              :label="$t('faktura.bkNr')"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <v-textarea v-show="$store.getters.showFaktura" v-model="editedItem.fakturaKopf.qrText1" :label="$t('faktura.qrText1')" rows="2" max="140" counter="140" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-textarea>
                          </v-col>
                          <v-col cols="6">
                            <v-textarea v-show="$store.getters.showFaktura" v-model="editedItem.fakturaKopf.qrText2" :label="$t('faktura.qrText2')" rows="2" max="140" counter="140" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn :disabled="checkNavigation('prior')" class="white--text" :color="$store.getters.stdColorDark" text @click="prior()">{{ $t("message.prior") }}</v-btn>
                      <v-btn :disabled="checkNavigation('next')" class="white--text" :color="$store.getters.stdColorDark" text @click="next()">{{ $t("message.next") }}</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="close()">{{ $t("message.cancel") }}</v-btn>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="save(true)">{{ $t("message.save") }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr :bgcolor="customRowClass(item.fakturaKopf)">
                <td>
                  <v-checkbox v-model="selected" :value="item"></v-checkbox>
                </td>

                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-show="!($store.getters.showFakturaVerbucht || $store.getters.showFakturaArchiv)" small class="mr-2" v-on="on" @click="editItem(item)">mdi-pencil</v-icon>
                    </template>
                    <span>{{ $t("tooltip.edit") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-show="$store.getters.showRapport || $store.getters.showOfferte || $store.getters.showAuftrag || $store.getters.showFaktura || $store.getters.showFakturaVerbucht" small class="mr-2" v-on="on" @click="changeItem(item)">mdi-hammer</v-icon>
                    </template>
                    <span>{{ getTooltipText() }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-show="$store.getters.showRapport || $store.getters.showOfferte || $store.getters.showAuftrag || $store.getters.showFaktura" small v-on="on" @click="cloneItem(item)">mdi-content-copy</v-icon>
                    </template>
                    <span>{{ $t("tooltip.clone") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-show="$store.getters.showRapport || $store.getters.showOfferte || $store.getters.showAuftrag || $store.getters.showFaktura || $store.getters.showFakturaArchiv" small v-on="on" @click="deleteItem(item)">mdi-delete</v-icon>
                    </template>
                    <span>{{ $t("tooltip.delete") }}</span>
                  </v-tooltip>
                </td>
                <td style="text-align:right">{{item.fakturaKopf.nr}}</td>
                <td v-show="!$store.getters.showRapport">{{getLocaleDisplayDate(item.fakturaKopf.datum)}}</td>
                <td v-show="$store.getters.showFakturaVerbucht || $store.getters.showFakturaArchiv">{{getLocaleDisplayDate(item.fakturaKopf.valutaDatum)}}</td>
                <td v-show="!$store.getters.showRapport">{{item.fakturaKopf.text}}</td>
                <td>{{item.fakturaKopf.nameFirma}}</td>
                <td>{{item.fakturaKopf.vorname}}</td>
                <td>{{item.fakturaKopf.plz}}</td>
                <td>{{item.fakturaKopf.ort}}</td>
                <td style="text-align:right">{{item.fakturaKopf.totalBetrag}}</td>
                <td v-show="!($store.getters.showFakturaVerbucht || $store.getters.showFakturaArchiv)">{{item.fakturaKopf.gedruckt}}</td>
                <td><v-icon @click="expandRow(item)">{{ getExpandIcon(item) }}</v-icon></td>
              </tr>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <faktura-pos-table v-bind:faktura="item" v-show="$store.getters.showFakturaPos && $store.getters.isLoggedOn"></faktura-pos-table>
              </td>
            </template>
          </v-data-table>
          <div>
            <v-pagination v-model="pageModel" :length="pageCount"></v-pagination>
            <v-text-field
              :value="itemsPerPage"
              :label="$t('message.itemsPerPage')"
              type="number"
              min="-1"
              max="100"
              @input="itemsPerPage = parseInt($event, 10)"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";
import FakturaPosTable from "@/components/FakturaPosTable";
import EntityHelper from "@/plugins/EntityHelper";

export default {
  name: "faktura-table",

  components: { FakturaPosTable
  },

  data() {
    return {
      webService: null,
      entityHelper: null,

      dialog: false,
      paidDialog: false,

      customerItem: this.$store.getters.customerList.find(o => o.nr === 0),
      lieferadresseItem: this.$store.getters.lieferadresseList.find(o => o.nr === 0),
      konditionItem: this.$store.getters.konditionList.find(o => o.code === 1),
      fzeileItem: this.$store.getters.fzeileList.find(o => o.code === 1),
      mahntextItem: this.$store.getters.mahntextList.find(o => o.code === 1),
      bankkontoItem: this.$store.getters.bankkontoList.find(o => o.nr === 1),
      editedIndex: -1,
      editedItem: {
        fakturaKopf:
        {
          mid: '',
          nr: 0,
          typ: 1,
          kundenNummer: 0,
          datum: new Date(),
          betragBezahlt: 0.0,
          betragPorto: 0.0,
          verbucht: 'N',
          valutaDatum: null,
          gedruckt: 'N',
          rabattCode: 1,
          konditionenCode: 1,
          mahnCode: 1,
          faktzeilenCode: 1,
          storno: 'N',
          totalBetrag: 0.0,
          text: '',
          person: '',
          bestellDatum: new Date(),
          bestellart: '',
          lieferadressenNr: 0,
          steuerBetrag: 0.0,
          nettoBetrag: 0.0,
          qrText1: '',
          qrText2: '',
          bankkonto: 1,

          calc: false
        },
        fakturaPosList: []
      },
      defaultItem: {
        fakturaKopf:
        {
          mid: '',
          nr: 0,
          typ: 1,
          kundenNummer: 0,
          datum: new Date(),
          betragBezahlt: 0.0,
          betragPorto: 0.0,
          verbucht: 'N',
          valutaDatum: null,
          gedruckt: 'N',
          rabattCode: 1,
          konditionenCode: 1,
          mahnCode: 1,
          faktzeilenCode: 1,
          storno: 'N',
          totalBetrag: 0.0,
          text: '',
          person: '',
          bestellDatum: new Date(),
          bestellart: '',
          lieferadressenNr: 0,
          steuerBetrag: 0.0,
          nettoBetrag: 0.0,
          qrText1: '',
          qrText2: '',
          bankkonto: 1,

          calc: false
        },
        fakturaPosList: []
      },

      //table
      selected: [],
      expanded: [],
      singleExpand: true,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,

      //menu
      menuDisabled: false,
      absolute: false,
      openOnHover: false,
      value: false,
      closeOnClick: true,
      closeOnContentClick: true,
      offsetX: false,
      offsetY: true
    };
  },

  created() {
    this.webService = new WebService(this)
    this.entityHelper = new EntityHelper(this)

    this.$store.watch(
      function(state) {
        return state.fakturaList;
      },
      // eslint-disable-next-line
      () => {
        // reset states on data change
        //this.expanded = [];
        this.selected = [];
        this.search = '';
      },
      {
        deep: true //add this if u need to watch object properties change etc.
      }
    );
  },

  computed: {
    getData() {
      return this.$store.getters.fakturaList;
    },

    headers() {
      if (this.$store.getters.showRapport)
      {
        return [
          {
            text: this.$t("message.actions"),
            value: 'actions',
            sortable: false
          },
          {
            text: this.$t("faktura.nr"),
            class: "blue-grey--text",
            align: "right",
            sortable: true,
            value: "fakturaKopf.nr"
          },
          {
            text: this.$t("customer.name"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.nameFirma"
          },
          {
            text: this.$t("customer.firstName"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.vorname"
          },
          {
            text: this.$t("customer.plz"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.plz"
          },
          {
            text: this.$t("customer.city"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.ort"
          },
          {
            text: this.$t("faktura.totalBetrag"),
            class: "blue-grey--text",
            align: "right",
            sortable: false,
            value: "fakturaKopf.totalBetrag"
          },
          {
            text: this.$t("faktura.gedruckt"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.gedruckt"
          },
          { text: "", value: "data-table-expand" }
        ];
      }
      else if (this.$store.getters.showFakturaVerbucht || this.$store.getters.showFakturaArchiv)
      {
        return [
          {
            text: this.$t("message.actions"),
            value: 'actions',
            sortable: false
          },
          {
            text: this.$t("faktura.nr"),
            class: "blue-grey--text",
            align: "right",
            sortable: true,
            value: "fakturaKopf.nr"
          },
          {
            text: this.$t("faktura.datum"),
            class: "blue-grey--text",
            sortable: false,
            value: "fakturaKopf.datum"
          },
          {
            text: this.$t("faktura.valutaDatum"),
            class: "blue-grey--text",
            sortable: false,
            value: "fakturaKopf.valutaDatum"
          },
          {
            text: this.$t("faktura.text"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.text"
          },
          {
            text: this.$t("customer.name"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.nameFirma"
          },
          {
            text: this.$t("customer.firstName"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.vorname"
          },
          {
            text: this.$t("customer.plz"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.plz"
          },
          {
            text: this.$t("customer.city"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.ort"
          },
          {
            text: this.$t("faktura.totalBetrag"),
            class: "blue-grey--text",
            align: "right",
            sortable: false,
            value: "fakturaKopf.totalBetrag"
          },
          { text: "", value: "data-table-expand" }
        ];
      }
      else
      {
        return [
          {
            text: this.$t("message.actions"),
            value: 'actions',
            sortable: false
          },
          {
            text: this.$t("faktura.nr"),
            class: "blue-grey--text",
            align: "right",
            sortable: true,
            value: "fakturaKopf.nr"
          },
          {
            text: this.$t("faktura.datum"),
            class: "blue-grey--text",
            sortable: false,
            value: "fakturaKopf.datum"
          },
          {
            text: this.$t("faktura.text"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.text"
          },
          {
            text: this.$t("customer.name"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.nameFirma"
          },
          {
            text: this.$t("customer.firstName"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.vorname"
          },
          {
            text: this.$t("customer.plz"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.plz"
          },
          {
            text: this.$t("customer.city"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.ort"
          },
          {
            text: this.$t("faktura.totalBetrag"),
            class: "blue-grey--text",
            align: "right",
            sortable: false,
            value: "fakturaKopf.totalBetrag"
          },
          {
            text: this.$t("faktura.gedruckt"),
            class: "blue-grey--text",
            sortable: true,
            value: "fakturaKopf.gedruckt"
          },
          { text: "", value: "data-table-expand" }
        ];
      }
    },

    formTitle () {
      return this.editedIndex === -1 ? this.$t("message.newTitle") : this.$t("message.editTitle")
    },

    pageModel: {
      get() {
        return this.page;
      },

      set(value) {
        this.selected = [];
        this.page = value;
      }
    },

    searchModel: {
      get() {
        return this.search;
      },

      set(value) {
        this.selected = [];
        this.search = value;
      }
    }
  },

  methods: {
    expandRow(item) {
      this.expanded = item === this.expanded[0] ? [] : [item];
    },

    getExpandIcon(item)
    {
      return item === this.expanded[0] ? 'mdi-chevron-up' : 'mdi-chevron-down'
    },

    customRowClass(item) {
      if (item==null)
        return ''

      if (this.editedIndex>=0)
      {
        return item.nr === this.editedItem.fakturaKopf.nr ? this.$store.getters.stdColorSelectedRow : ''
      }
      else
        return ''
    },

    getTitle()
    {
      if (this.$store.getters.showFaktura)
        return this.$t("message.fakturaData")
      if (this.$store.getters.showFakturaVerbucht)
        return this.$t("message.fakturaVerbuchtData")
      if (this.$store.getters.showRapport)
        return this.$t("message.rapporteData")
      if (this.$store.getters.showOfferte)
        return this.$t("message.offertenData")
      if (this.$store.getters.showAuftrag)
        return this.$t("message.auftragData")
      if (this.$store.getters.showFakturaArchiv)
        return this.$t("message.fakturaArchivData")
    },

    getTooltipText()
    {
      if (this.$store.getters.showRapport)
        return this.$t("tooltip.changeToFaktura")
      if (this.$store.getters.showOfferte)
        return this.$t("tooltip.changeToOrder")
      if (this.$store.getters.showAuftrag)
        return this.$t("tooltip.changeToFaktura")
      if (this.$store.getters.showFaktura)
        return this.$t("tooltip.changeToPaid")
      if (this.$store.getters.showFakturaVerbucht)
        return this.$t("tooltip.changeToArchiv")
    },

    getIcon()
    {
      if (this.$store.getters.showFaktura)
        return "mdi-receipt"
      if (this.$store.getters.showFakturaVerbucht)
        return "mdi-cash-100"
      if (this.$store.getters.showRapport)
        return "mdi-card-text-outline"
      if (this.$store.getters.showOfferte)
        return "mdi-text"
      if (this.$store.getters.showAuftrag)
        return "mdi-card-text"
      if (this.$store.getters.showFakturaArchiv)
        return "mdi-credit-card"
    },

    getCustomerText: item =>
      item.nr.toString() + ":" + item.nameFirma+" "+item.plz+" "+item.ort,

    getCustomerValue: item => item,

    getLieferadresseText: item =>
      item.nr.toString() + ":" + item.nameFirma+" "+item.plz+" "+item.ort,

    getLieferadresseValue: item => item,

    getKonditionText: item =>
      item.code.toString() + ":" + item.text,

    getKonditionValue: item => item,

    getFzeileText: item =>
      item.code.toString() + ":" + item.text,

    getFzeileValue: item => item,

    getBankkontoText: item =>
      item.nr.toString() + ":" + item.bank +" "+item.iban,

    getBankkontoValue: item => item,

    initItem()
    {
      this.editedItem.fakturaKopf.typ = this.getFakturaTyp(),
      this.konditionItem = this.$store.getters.konditionList.find(o => o.code === this.defaultItem.fakturaKopf.konditionenCode);
      this.fzeileItem = this.$store.getters.fzeileList.find(o => o.code === this.defaultItem.fakturaKopf.faktzeilenCode);
      this.mahntextItem = this.$store.getters.mahntextList.find(o => o.code === this.defaultItem.fakturaKopf.mahnCode);
      this.bankkontoItem = this.$store.getters.bankkontoList.find(o => o.nr === this.defaultItem.fakturaKopf.bankkonto);
    },

    changeItem(item)
    {
      if (this.$store.getters.showFaktura)
      {
        this.editedIndex = this.$store.getters.fakturaList.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.fakturaKopf.valutaDatum=new Date().toISOString()
        this.paidDialog=true;
        return
      }

      var restUrl;
      if (this.$store.getters.showRapport)
        restUrl=this.$store.getters.changeRapportToFaktura
      if (this.$store.getters.showOfferte)
        restUrl=this.$store.getters.changeOfferteToAuftrag
      if (this.$store.getters.showAuftrag)
        restUrl=this.$store.getters.changeAuftragToFaktura
      if (this.$store.getters.showFakturaVerbucht)
        restUrl=this.$store.getters.changeFakturaToArchiv

      this.webService.changeItem(restUrl, item, false)
        .then(response => {
          if (response.request.status==201)
          {
            if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
            {
              //re-read faktura data
              this.webService.getItems(this.$store.getters.fakturaEntities+"/"+this.getFakturaTyp().toString())
                .then(response => {
                  this.$store.dispatch("setFakturaList", response.data);
                })
                .catch(err => { console.log(err) });
            }
            else
            {
              this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
            }
          }
        })
        .catch(err => { console.log(err) });
    },

    editItem(item)
    {
      this.editedIndex = this.$store.getters.fakturaList.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.customerItem = this.$store.getters.customerList.find(o => o.nr === item.fakturaKopf.kundenNummer),

      //read lieferadressen data
      this.webService.getChildItems(this.$store.getters.lieferadresseBase,[item.fakturaKopf.kundenNummer])
        .then(response => {
          this.$store.dispatch("setLieferadresseList", response.data);
          if (item.fakturaKopf.lieferadressenNr>0)
            this.lieferadresseItem = response.data.find(o => o.nr === item.fakturaKopf.lieferadressenNr);
          else
            this.lieferadresseItem = null;
        })
        .catch(err => { console.log(err) });

      this.konditionItem = this.$store.getters.konditionList.find(o => o.code === item.fakturaKopf.konditionenCode);
      this.fzeileItem = this.$store.getters.fzeileList.find(o => o.code === item.fakturaKopf.faktzeilenCode);
      this.mahntextItem = this.$store.getters.mahntextList.find(o => o.code === item.fakturaKopf.mahnCode);
      this.bankkontoItem = this.$store.getters.bankkontoList.find(o => o.nr === item.fakturaKopf.bankkonto);

      this.dialog = true
    },

    cloneItem(item)
    {
      this.webService.cloneItem(this.$store.getters.cloneFaktura,item)
        .then(response => {
          if (response.request.status==201)
          {
            if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
            {
              //re-read faktura data
              this.webService.getItems(this.$store.getters.fakturaEntities+"/"+this.getFakturaTyp().toString())
                .then(response => {
                  this.$store.dispatch("setFakturaList", response.data);
                })
                .catch(err => { console.log(err) });
            }
          }
        })
        .catch(err => { console.log(err) });
    },

    deleteItem(item)
    {
      //delete item
      this.$store.dispatch("setConfirmDialog", { showConfirmDialog: true, message: this.$t("message.confirmDelete"), action: "deleteFakturaRecord", params: [item] });
    },

    close()
    {
      this.dialog=false;
      this.paidDialog=false;
      setTimeout(() => {
        this.defaultItem.fakturaKopf.typ = this.getFakturaTyp()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save(closeOnSave)
    {
      this.editedItem.fakturaKopf.kundenNummer=this.customerItem.nr;
      if (this.lieferadresseItem!=null)
        this.editedItem.fakturaKopf.lieferadressenNr=this.lieferadresseItem.nr;
      else
        this.editedItem.fakturaKopf.lieferadressenNr=0;

      this.editedItem.fakturaKopf.konditionenCode=this.konditionItem.code;
      this.editedItem.fakturaKopf.faktzeilenCode=this.fzeileItem.code;
      if (this.mahntextItem!=null)
        this.editedItem.fakturaKopf.mahnCode=this.mahntextItem.code;
      else
        this.editedItem.fakturaKopf.mahnCode=0;
      this.editedItem.fakturaKopf.bankkonto=this.bankkontoItem.nr;

      if (this.editedIndex > -1) {
        this.webService.updateItem(this.$store.getters.fakturaBase, this.editedItem, [this.editedItem.fakturaKopf.nr])
          .then(response => {
            if (response.request.status==200)
            {
              if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
              {
                //re-read faktura data
                this.webService.getItems(this.$store.getters.fakturaEntities+"/"+this.getFakturaTyp().toString())
                  .then(response => {
                    this.$store.dispatch("setFakturaList", response.data);
                  })
                  .catch(err => { console.log(err) });
              }
              else
              {
                this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
              }
            }
          })
          .catch(err => { console.log(err) });
      } else {
        this.webService.insertItem(this.$store.getters.fakturaBase, this.editedItem)
          .then(response => {
            if (response.request.status==201)
            {
              if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
              {
                //re-read faktura data
                this.webService.getItems(this.$store.getters.fakturaEntities+"/"+this.getFakturaTyp().toString())
                  .then(response => {
                    this.$store.dispatch("setFakturaList", response.data);
                  })
                  .catch(err => { console.log(err) });
              }
              else
              {
                this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
              }
            }
          })
          .catch(err => { console.log(err) });
      }
      if (closeOnSave)
        this.close();
    },

    prior()
    {
      this.save(false)
      this.editedIndex--
      this.editedItem = Object.assign({}, this.$store.getters.fakturaList[this.editedIndex])

      this.customerItem = this.$store.getters.customerList.find(o => o.nr === this.editedItem.fakturaKopf.kundenNummer),
      this.lieferadresseItem = this.$store.getters.lieferadresseList.find(o => o.nr === this.editedItem.fakturaKopf.lieferadressenNr),
      this.konditionItem = this.$store.getters.konditionList.find(o => o.code === this.editedItem.fakturaKopf.konditionenCode);
      this.fzeileItem = this.$store.getters.fzeileList.find(o => o.code === this.editedItem.fakturaKopf.faktzeilenCode);
      this.mahntextItem = this.$store.getters.mahntextList.find(o => o.code === this.editedItem.fakturaKopf.mahnCode);
      this.bankkontoItem = this.$store.getters.bankkontoList.find(o => o.nr === this.editedItem.fakturaKopf.bankkonto);
    },

    next()
    {
      this.save(false)
      this.editedIndex++
      this.editedItem = Object.assign({}, this.$store.getters.fakturaList[this.editedIndex])
      
      this.customerItem = this.$store.getters.customerList.find(o => o.nr === this.editedItem.fakturaKopf.kundenNummer),
      this.lieferadresseItem = this.$store.getters.lieferadresseList.find(o => o.nr === this.editedItem.fakturaKopf.lieferadressenNr),
      this.konditionItem = this.$store.getters.konditionList.find(o => o.code === this.editedItem.fakturaKopf.konditionenCode);
      this.fzeileItem = this.$store.getters.fzeileList.find(o => o.code === this.editedItem.fakturaKopf.faktzeilenCode);
      this.mahntextItem = this.$store.getters.mahntextList.find(o => o.code === this.editedItem.fakturaKopf.mahnCode);
      this.bankkontoItem = this.$store.getters.bankkontoList.find(o => o.nr === this.editedItem.fakturaKopf.bankkonto);
    },

    checkNavigation(mode)
    {
      //new record
      if (this.editedIndex==-1)
        return true
      if (mode=='prior')
      {
        return !(this.editedIndex>0)
      }
      else
      {
        return !(this.editedIndex<(this.$store.getters.fakturaList.length-1))
      }
    },

    calcItem(item)
    {
      if (this.editedIndex > -1)
      {
        this.webService
          .calcItem(this.$store.getters.calcInvoice, item)
          .then(response => {
            this.editedItem.fakturaKopf.nettoBetrag = this.roundNumber(response.data.fakturaKopf.nettoBetrag)
            this.editedItem.fakturaKopf.steuerBetrag = this.roundNumber(response.data.fakturaKopf.steuerBetrag)
            this.editedItem.fakturaKopf.totalBetrag = this.roundNumber(response.data.fakturaKopf.totalBetrag)
          });
      }
      return;
    },

    setPaid()
    {
      this.webService.changeInvoiceToPaid(this.$store.getters.changeFakturaToPaid, this.editedItem)
        .then(response => {
          if (response.request.status==201)
          {
            if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
            {
              //re-read faktura data
              this.webService.getItems(this.$store.getters.fakturaEntities+"/"+this.getFakturaTyp().toString())
                .then(response => {
                  this.$store.dispatch("setFakturaList", response.data);
                })
                .catch(err => { console.log(err) });
            }
            else
            {
              this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
            }
          }
        })
        .catch(err => { console.log(err) });
      this.close();
    },

    checkDate(item)
    {
      try
      {
        if (new Date(item.fakturaKopf.valutaDatum).getTime()>new Date(item.fakturaKopf.datum).getTime())
          return true
        else
          return false
      } catch(e)
      {
        return false
      }
    },

    getFakturaTyp()
    {
      if (this.$store.getters.showFaktura)
        return this.$store.getters.FAKTURA_FAKTURA
      if (this.$store.getters.showRapport)
        return this.$store.getters.FAKTURA_RAPPORT
      if (this.$store.getters.showOfferte)
        return this.$store.getters.FAKTURA_OFFERTE
      if (this.$store.getters.showAuftrag)
        return this.$store.getters.FAKTURA_AUFTRAG
      if (this.$store.getters.showFakturaVerbucht)
        return this.$store.getters.FAKTURA_VERBUCHT
      if (this.$store.getters.showFakturaArchiv)
        return this.$store.getters.FAKTURA_ARCHIV
    },

    getReportFormName()
    {
      if (this.$store.getters.showFaktura)
        return 'optimaw_invoice [FORM]'
      if (this.$store.getters.showRapport)
        return 'optimaw_rapport [FORM]'
      if (this.$store.getters.showOfferte)
        return 'optimaw_offerte [FORM]'
      if (this.$store.getters.showAuftrag)
        return 'optimaw_auftrag [FORM]'
      if (this.$store.getters.showFakturaVerbucht)
        return 'optimaw_quittung [FORM]'
    },

    getReportFormNameLeft()
    {
      if (this.$store.getters.showFaktura)
        return 'optimaw_invoice_l [FORM]'
      if (this.$store.getters.showRapport)
        return 'optimaw_rapport_l [FORM]'
      if (this.$store.getters.showOfferte)
        return 'optimaw_offerte_l [FORM]'
      if (this.$store.getters.showAuftrag)
        return 'optimaw_auftrag_l [FORM]'
      if (this.$store.getters.showFakturaVerbucht)
        return 'optimaw_quittung_l [FORM]'
    },

    getReportFormTitle()
    {
      if (this.$store.getters.showFaktura)
        return this.$t('reports.fakturaFormReport')
      if (this.$store.getters.showRapport)
        return this.$t('reports.rapportFormReport')
      if (this.$store.getters.showOfferte)
        return this.$t('reports.offerteFormReport')
      if (this.$store.getters.showAuftrag)
        return this.$t('reports.auftragFormReport')
      if (this.$store.getters.showFakturaVerbucht)
        return this.$t('reports.fakturaVerbuchtFormReport')
    },

    getReportFormTitleLeft()
    {
      if (this.$store.getters.showFaktura)
        return this.$t('reports.fakturaFormReportLeft')
      if (this.$store.getters.showRapport)
        return this.$t('reports.rapportFormReportLeft')
      if (this.$store.getters.showOfferte)
        return this.$t('reports.offerteFormReportLeft')
      if (this.$store.getters.showAuftrag)
        return this.$t('reports.auftragFormReportLeft')
      if (this.$store.getters.showFakturaVerbucht)
        return this.$t('reports.fakturaVerbuchtFormReportLeft')
    },

    getReportListName()
    {
      if (this.$store.getters.showFaktura)
        return 'Fakturaliste [LIST]'
      if (this.$store.getters.showRapport)
        return 'Rapportliste [LIST]'
      if (this.$store.getters.showOfferte)
        return 'Offertliste [LIST]'
      if (this.$store.getters.showAuftrag)
        return 'Auftragsliste [LIST]'
      if (this.$store.getters.showFakturaVerbucht)
        return 'FakturaVerbuchtliste [LIST]'
    },

    getReportListTitle()
    {
      if (this.$store.getters.showFaktura)
        return this.$t('reports.fakturaListReport')
      if (this.$store.getters.showRapport)
        return this.$t('reports.rapportListReport')
      if (this.$store.getters.showOfferte)
        return this.$t('reports.offerteListReport')
      if (this.$store.getters.showAuftrag)
        return this.$t('reports.auftragListReport')
      if (this.$store.getters.showFakturaVerbucht)
        return this.$t('reports.fakturaVerbuchtListReport')
    },

    getLocaleDisplayDate(isoDate)
    {
      if (isoDate!=null)
        return new Date(isoDate).toLocaleDateString('de-CH');
      else
        return isoDate;
    },

    roundNumber(number)
    {
      return Number(Math.round(number+'e2')+'e-2');
    },

    showReport(reportName,reportTitle)
    {
      if (this.selected.length==0)
        return
      
      var birtReportname=reportName.substring(0, reportName.indexOf('[')-1)
      var reportType=reportName.substring(reportName.indexOf('[')+1, reportName.indexOf(']'))
      var values = this.selected.map(item => item.fakturaKopf.nr);
      var qrslipReportname = this.getFakturaTyp()==this.$store.getters.FAKTURA_FAKTURA ? 'optimaw_invoice_qrslip' : '';
      //var qrslipReportname = '';

      this.webService.getItem(this.$store.getters.paramsBase,[this.selected[0].fakturaKopf.mid])
        .then(response => {
          this.webService.getQRSlips(this.$store.getters.getQRSlips,this.$store.getters.selectedLanguage,values)
            .then(responseQRSlips => {
              this.$store.dispatch("setReport", { showReport: true, name: birtReportname, title: reportTitle,
                reportData: {
                  name: birtReportname,
                  qrName: qrslipReportname,
                  outputType: 'HTML',
                  inputType: reportType,
                  language: this.$store.getters.selectedLanguage,
                  parameters: [
                    {
                      title: 'Mandant',
                      name: 'mandantenId',
                      type: 'STRING',
                      value: this.selected[0].fakturaKopf.mid
                    },
                    {
                      title: 'Rechnungsnummer',
                      name: 're_nr',
                      type: 'INT',
                      value: -1
                    },
                    {
                      title: 'Steuercode',
                      name: 'st_code',
                      type: 'INT',
                      value: this.$store.getters.taxCode
                    }
                  ],
                  dataSets: [
                    {
                      name: 'Data Set Invoice',
                      tables: [
                        {
                          schema: 'optimaw',
                          name: 'faktura',
                          primaryKeys: [
                            {
                              name: 're_nr',
                              type: 'int'
                            },
                            {
                              name: 're_mid',
                              type: 'string'
                            }
                          ]
                        }
                      ],
                      selections: [
                        {
                          schema: 'optimaw',
                          table: 'faktura',
                          field: 're_nr',
                          type: 'int',
                          values: values,
                          images: responseQRSlips.data
                        }
                      ]
                    }
                  ],
                  images: [
                    {
                      title: 'Logo',
                      name: 'logo',
                      type: response.data.logoType.toUpperCase(),
                      base64Value: response.data.logoBase64Encoded
                    }
                  ]
                }
              });
            })
            .catch(err => { console.log(err) });
        })
        .catch(err => { console.log(err) });
    }

  },

  watch: {
    expanded: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal.length>0)
        {
          // do something when row is expanded, probably re-read some data
          this.entityHelper.setFakturaPosState(true);
        }
        else
        {
          this.entityHelper.setFakturaPosState(false);
        }
      }
    },

    customerItem: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal!==null)
        {
          this.editedItem.fakturaKopf.person = newVal.sachbearbeiter;
          //read lieferadressen data
          this.webService.getChildItems(this.$store.getters.lieferadresseBase,[this.customerItem.nr])
            .then(response => {
              this.$store.dispatch("setLieferadresseList", response.data);
              if (this.editedItem.fakturaKopf.lieferadressenNr>0)
                this.lieferadresseItem = response.data.find(o => o.nr === this.editedItem.fakturaKopf.lieferadressenNr);
              else
                this.lieferadresseItem = null;
            })
            .catch(err => { console.log(err) });
        }
      }
    },

    dialog (val) {
      val || this.close()
    }
  }

};
</script>

<style scoped>
.large-slider >>> .v-slider {
  height: 60px;
}
</style>
